const DEDICATED_OR_EXCLUDED_PATHS = [
  "/alerts",
  "/settings",
  "/taste",
  "/telegram",
  "/whatsapp",
] as const;

export function isAuthPath(pathname: string) {
  return ["/login", "/forgot-password", "/reset-password"].some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function shouldShowMessagingPrompt(pathname: string, signupOpen: boolean) {
  if (isAuthPath(pathname) || signupOpen) return false;
  if (pathname === "/onboarding" || pathname.startsWith("/onboarding/")) return false;
  return !DEDICATED_OR_EXCLUDED_PATHS.includes(
    pathname as (typeof DEDICATED_OR_EXCLUDED_PATHS)[number],
  );
}
